import {Button, Typography} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import {LoginBackground} from './LoginBackground';

import type {FC, ReactNode} from 'react';

interface AuthErrorScreenProps {
  errorCode: string;
  onRetry: () => void;
  background?: ReactNode;
}

export const AuthErrorScreen: FC<AuthErrorScreenProps> = ({errorCode, onRetry, background}) => {
  const {t} = useTranslation('auth');

  return (
    <LoginBackground background={background}>
      <div className="bg-background-surface flex w-105 flex-col items-center gap-6 rounded-2xl px-10 py-12 text-center shadow-md">
        <div className="flex flex-col gap-2">
          <Typography size="lg" weight="semibold">
            {t(`error.${errorCode}.title`, {defaultValue: t('error.unknown.title')})}
          </Typography>
          <Typography size="sm" color="secondary">
            {t(`error.${errorCode}.description`, {defaultValue: t('error.unknown.description')})}
          </Typography>
        </div>
        <Button className="w-full" onClick={onRetry}>
          {t('error.backToLogin')}
        </Button>
      </div>
    </LoginBackground>
  );
};
